<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-missing-adoption-unprocessed
        *ngSwitchCase="0"
      ></app-missing-adoption-unprocessed>
      <app-missing-adoption-processed
        *ngSwitchCase="1"
      ></app-missing-adoption-processed>
    </ng-container>
  </div>
</div>
